import { ComponentDefaultMessageVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (title: string): Promise<ComponentDefaultMessageVO> =>
  fetcher(`/api/defaultMessage/title/${title}`, 'GET', undefined)
